module.exports = __webpack_public_path__ + "static/img/zry.2243a09.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/classmates/zry.png
// module id = JmaJ
// module chunks = 43